import React from 'react';
import DetalhePacienteDorComponent from './components/DetalhePacienteDor';

const DetalhePacienteDor = () => {
  console.log('Render DetalhePacienteDor');
  return (
    <DetalhePacienteDorComponent />
  );
};

export default DetalhePacienteDor; 